import React, { useState } from "react";
import "./SelectGlobal.scss";
import cn from "classnames";

const SelectGlobal = ({
  data,
  error,
  handleChange,
  dateArray,
  customClass,
  label,
  disabled = false,
  useIndexAsValue = false,
}) => {
  const [value] = useState("default");

  return (
    <div className={cn("select-container", `aqa-test-${label.toLowerCase()}`)}>
      <label
        className={cn("floating-label", {
          active: data,
          error,
          disabled,
        })}
      >
        {label}
      </label>
      <select
        className={cn("select-input", { active: data, error })}
        onChange={handleChange}
        value={data || value}
        disabled={disabled}
      >
        <option value="default" disabled hidden />
        {dateArray.map((item, index) => (
          <option
            key={index}
            value={useIndexAsValue && label !== "Year" ? index + 1 : item}
          >
            {item || ""}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectGlobal;
